import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Select, Table, Tag, Tabs, Popover, Button, Modal, Form,notification } from "antd";
import "flatpickr/dist/flatpickr.min.css";
import Flatpickr from "flatpickr";
import ReactApexChart from "react-apexcharts";
import Swal from "sweetalert2";
import axios from "axios";
import {
  updateApprovalStatus,
  updateShortApproval,
  getEmployeeLeaveWithEmployee,
  getSearchResults,
  fetchShortLeaves,
  fetchDutyLeaves,
  updateApproval,
  searchShortLeaves,
  searchDutyLeaves,
  fetchSpecialLeaves,
  updateSpecialApproval,
  searchSpecialLeaves,
  updateMaternityApprovalById,
  fetchMaternityLeaves,
  searchMaternityLeaves,
  adjustMaternityLeaveDatesCustom,
  searchAuthorizedNoPayLeaves
} from "../../service/leavesEmployeeApiService";
import okilogo from "../../assets/OKI-logo.png";
import jsPDF from "jspdf";
import dayjs from "dayjs";
import ExcelJS from "exceljs";
import { DatePicker, Space } from "antd";
import BulkUploadModal from "../../feature-module/hrm/leavesAdminBulkUpload";
import { Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";
import moment from "moment";
import AddMaternityLeave from "../../core/modals/hrm/AddMaternityLeave";
import { getLeaveAllocationByEmployeeId } from "../../service/leaveAllocationService"; 
import AddAuthorizedNoPayLeave from "../../core/modals/hrm/AddAuthorizedNoPayLeave";

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

const LeavesAdmin = () => {
  const { Option } = Select;

  const getDocUrl = (documentPath) => {
    if (!documentPath) return "";
    let cleanPath = documentPath.replace(/\\/g, '/');
    if (!cleanPath.startsWith('/') && !cleanPath.startsWith('http')) {
      cleanPath = '/' + cleanPath;
    }
    const backendBase = axios.defaults.baseURL.replace('/api', '');
    return cleanPath.startsWith('http') ? cleanPath : `${backendBase}${cleanPath}`;
  };

  const handleViewDocument = (documentPath) => {
    const fileUrl = getDocUrl(documentPath);
    if (fileUrl) {
      window.open(fileUrl, '_blank');
    }
  };
  const { user } = useContext(UserContext);
  const location = useLocation();
  const dashboardState = location.state;
  
  const [dataSource, setDataSource] = useState([]);
  const [groupedData, setgroupedData] = useState([]);
  const [tempStatus, setTempStatus] = useState({});
  const [tempStatusduty, setTempdutyStatus] = useState({});
  const [tempStatusShort, setTempShortStatus] = useState({});
  const [tempStatusSpecial, setTempSpecialStatus] = useState({});
  const [tempStatusMaternity, setTempMaternityStatus] = useState({});
  const [epf_number, setEpf] = useState("");
  const [leaveType, setLeaveType] = useState("");
  const [name, setName] = useState("");
  const [branch, setBranch] = useState(
    dashboardState?.fromDashboard && dashboardState?.branch
      ? dashboardState.branch
      : null
  );
  const [startDate, setStartDate] = useState(
    dashboardState?.fromDashboard && dashboardState?.startDate
      ? dashboardState.startDate
      : null
  );
  const [endDate, setEndDate] = useState(
    dashboardState?.fromDashboard && dashboardState?.endDate
      ? dashboardState.endDate
      : null
  );
  const [dateRange, setDateRange] = useState(
    dashboardState?.fromDashboard && dashboardState?.startDate && dashboardState?.endDate
      ? [dayjs(dashboardState.startDate), dayjs(dashboardState.endDate)]
      : null
  );
  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading5, setLoading5] = useState(false); 
  const [shortLeaves, setShortLeaves] = useState([]);
  const [dutyLeaves, setDutyLeaves] = useState([]);
  const [specialLeaves, setSpecialLeaves] = useState([]);
  const [maternityLeaves, setMaternityLeaves] = useState([]);
  const [leavesCount, setLeavesCount] = useState(0);
  const [shortLeavesCount, setShortLeavesCount] = useState(0);
  const [dutyLeavesCount, setDutyLeavesCount] = useState(0);
  const [specialLeavesCount, setSpecialLeavesCount] = useState(0);
  const [maternityLeavesCount, setMaternityLeavesCount] = useState(0);
  const [authorizedNoPayLeaves, setAuthorizedNoPayLeaves] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false);
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize);
  const [currentTab, setCurrentTab] = useState("1");
  const pageSizeOptions = [5, 10, 20, 50, 100];
  const [isAdjustDateModalVisible, setIsAdjustDateModalVisible] =
    useState(false);
  const [selectedLeaveId, setSelectedLeaveId] = useState(null);
  const [isAddMaternityModalOpen, setIsAddMaternityModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const [leaveDays, setLeaveDays] = useState([]);
    const [addModalVisible, setAddModalVisible] = useState(false);
  

  const formatAttendanceTypeLabel = (value) => {
    if (!value) return "-";
    const label = value.toString().trim().toUpperCase();
    switch (label) {
      case "FIRST HALF":
        return "First Half";
      case "SECOND HALF":
        return "Second Half";
      case "FULL DAY":
        return "Full Day";
      default:
        return value;
    }
  };

  const buildCoverupName = (item) => {
    if (!item) return "-";
    return (
      item.coverupEmployeeName ||
      item.coverupEmployeeDetails?.full_name ||
      `${item.coverupEmployeeDetails?.first_name || ""} ${item.coverupEmployeeDetails?.last_name || ""}`.trim() ||
      "-"
    );
  };


  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const showNotification = (type, message, description) => {
    api[type]({
      message,
      description,
      placement: "topRight",
      duration: 4.5,
    });
  };

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 };
    setPagination(newPagination);
    setPageSizeModalVisible(false);
  };

const handleAdjustDate = (record) => {
    setSelectedLeaveId(record._id);
    // Use leaveDays from the database instead of generating a new array
    const storedLeaveDays = record.leaveDays && Array.isArray(record.leaveDays)
      ? record.leaveDays.map((day) => moment(day.date).format("YYYY-MM-DD"))
      : getDateRangeArray(new Date(record.startDate), new Date(record.endDate)).map((date) =>
          moment(date).format("YYYY-MM-DD")
        );
    setLeaveDays(storedLeaveDays);
    form.setFieldsValue({
      startDate: record.startDate ? moment(record.startDate).format("YYYY-MM-DD") : null,
      endDate: record.endDate ? moment(record.endDate).format("YYYY-MM-DD") : null,
      expectedDeliveryDate: record.expectedDeliveryDate
        ? moment(record.expectedDeliveryDate).format("YYYY-MM-DD")
        : null,
    });
    setIsAdjustDateModalVisible(true);
  };

   const handleAddModalSuccess = () => {
  console.log("Add modal success callback triggered");
  setCurrentTab("6"); // Switch to Authorized No Pay Leaves tab
  getSeachData(); // Refresh the data
};


  const getDateRangeArray = (start, end) => {
    const dates = [];
    let currentDate = new Date(start);
    while (currentDate <= end) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };

  const handleRemoveDate = async (dateToRemove) => {
    // Update local state
    const updatedLeaveDays = leaveDays.filter((date) => date !== dateToRemove);
    setLeaveDays(updatedLeaveDays);

    // Prepare payload for backend
    try {
      const values = await form.validateFields();
      const { startDate, endDate, expectedDeliveryDate } = values;

      if (
        !startDate ||
        !endDate ||
        !expectedDeliveryDate ||
        !moment(startDate).isValid() ||
        !moment(endDate).isValid() ||
        !moment(expectedDeliveryDate).isValid()
      ) {
     showNotification(
        "error",
        "Error",
        "Invalid date selected. Please choose valid dates."
      );
        return;
      }

      const startMoment = moment(startDate);
      const endMoment = moment(endDate);
      const deliveryMoment = moment(expectedDeliveryDate);

      if (endMoment.isBefore(startMoment)) {
      showNotification(
        "error",
        "Error",
        "End date must be after start date."
      );
        return;
      }

      if (deliveryMoment.isBefore(startMoment) || deliveryMoment.isAfter(endMoment)) {
   showNotification(
        "error",
        "Error",
        "Expected delivery date must be within the leave period."
      );
        return;
      }

      const payload = {
        userId: userObj._id,
        startDate: startMoment.format("YYYY-MM-DD"),
        endDate: endMoment.format("YYYY-MM-DD"),
        expectedDeliveryDate: deliveryMoment.format("YYYY-MM-DD"),
        leaveDays: updatedLeaveDays.map((date) => ({
          date,
          Day: "FULL DAY",
        })),
      };

      // Call the API to update the backend
      const response = await adjustMaternityLeaveDatesCustom(selectedLeaveId, payload);

      if (response.status === "success") {
        // Update local maternityLeaves state
        setMaternityLeaves((prev) =>
          prev.map((leave) =>
            leave._id === selectedLeaveId
              ? {
                  ...leave,
                  startDate: new Date(payload.startDate),
                  endDate: new Date(payload.endDate),
                  expectedDeliveryDate: new Date(payload.expectedDeliveryDate),
                  leaveDays: payload.leaveDays,
                }
              : leave
          )
        );

      showNotification(
        "success",
        "Success!",
        "Leave day removed successfully."
      );
      }
    } catch (error) {
      console.error("Error removing leave day:", error);
    showNotification(
      "error",
      "Error",
      error.response?.data?.message || "Failed to remove leave day."
    );
      setLeaveDays(leaveDays);
    }
  };

  const handleAdjustDateSubmit = async () => {
  try {
    const values = await form.validateFields();
    const { startDate, endDate, expectedDeliveryDate } = values;

    if (
      !startDate ||
      !endDate ||
      !expectedDeliveryDate ||
      !moment(startDate).isValid() ||
      !moment(endDate).isValid() ||
      !moment(expectedDeliveryDate).isValid()
    ) {
   showNotification(
        "error",
        "Error",
        "Invalid date selected. Please choose valid dates."
      );
      return;
    }

    const startMoment = moment(startDate);
    const endMoment = moment(endDate);
    const deliveryMoment = moment(expectedDeliveryDate);

    if (endMoment.isBefore(startMoment)) {
   showNotification(
        "error",
        "Error",
        "End date must be after start date."
      );
      return;
    }

    if (deliveryMoment.isBefore(startMoment) || deliveryMoment.isAfter(endMoment)) {
 showNotification(
        "error",
        "Error",
        "Expected delivery date must be within the leave period."
      );
      return;
    }

    const payload = {
      userId: userObj._id,
      startDate: startMoment.format("YYYY-MM-DD"),
      endDate: endMoment.format("YYYY-MM-DD"),
      expectedDeliveryDate: deliveryMoment.format("YYYY-MM-DD"),
      leaveDays: leaveDays.map((date) => ({
        date,
        Day: "FULL DAY",
      })),
    };

    console.log("Submitting payload:", payload); // Add this for debugging

    const response = await adjustMaternityLeaveDatesCustom(selectedLeaveId, payload);

    if (response.status === "success") {
      setMaternityLeaves((prev) =>
        prev.map((leave) =>
          leave._id === selectedLeaveId
            ? {
                ...leave,
                startDate: new Date(payload.startDate),
                endDate: new Date(payload.endDate),
                expectedDeliveryDate: new Date(payload.expectedDeliveryDate),
                leaveDays: payload.leaveDays,
              }
            : leave
        )
      );

    showNotification(
        "success",
        "Success!",
        "Maternity leave dates adjusted successfully."
      );
      setIsAdjustDateModalVisible(false);
      form.resetFields();
      setSelectedLeaveId(null);
      setLeaveDays([]);
    }
  } catch (error) {
    console.error("Error adjusting maternity leave dates:", error);
showNotification(
      "error",
      "Error",
      error.response?.data?.message || "Failed to adjust maternity leave dates."
    );
  }
};

const handleCancelModal = () => {
  if (leaveDays.length !== getDateRangeArray(form.getFieldValue("startDate"), form.getFieldValue("endDate")).length) {
    showNotification(
      "warning",
      "Unsaved Changes",
      <div>
        You have unsaved changes to the leave days. Do you want to save them before closing?
        <div style={{ marginTop: "16px", display: "flex", gap: "8px" }}>
          <Button
            type="primary"
            style={{ backgroundColor: "#00ff00", borderColor: "#00ff00" }}
            onClick={() => {
              handleAdjustDateSubmit(); // Save changes
              api.destroy(); // Close the notification
            }}
          >
            Save
          </Button>
          <Button
            danger
            onClick={() => {
              setIsAdjustDateModalVisible(false);
              form.resetFields();
              setSelectedLeaveId(null);
              setLeaveDays([]);
              api.destroy(); // Close the notification
            }}
          >
            Discard
          </Button>
        </div>
      </div>
    );
  } else {
    setIsAdjustDateModalVisible(false);
    form.resetFields();
    setSelectedLeaveId(null);
    setLeaveDays([]);
  }
};

  const branchOptions = [
      { value: "wattala", label: "Wattala" },
      { value: "negombo", label: "Negombo" },
      { value: "kaduwela", label: "Kaduwela" },
      { value: "kiribathgoda", label: "Kiribathgoda" },
      { value: "kandana", label: "Kandana" },
      { value: "delgoda", label: "Delgoda" },
      { value: "lsu", label: "Wattala LSU" },
      { value: "cityschool", label: "City School - Negombo" }
  ];

  const onChange = (dates, dateStrings) => {
    setStartDate(dateStrings[0]);
    setEndDate(dateStrings[1]);
    setDateRange(dates);
  };

  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  const userObj = userData?.data;

  useEffect(() => {
    const fetchShortLeaveData = async () => {
      if (!userObj) return;
      try {
        setLoading(true);

        // 1. Fetch Short Leaves
        let normalizedShortLeaves = [];
        try {
          const response = await fetchShortLeaves(userObj._id);
          if (response && Array.isArray(response.data)) {
            normalizedShortLeaves = response.data.map((leave) => ({
              ...leave,
              date: leave.date
                ? new Date(
                    Date.UTC(
                      new Date(leave.date).getUTCFullYear(),
                      new Date(leave.date).getUTCMonth(),
                      new Date(leave.date).getUTCDate()
                    )
                  )
                : null,
              document: leave.document,
            }));
          }
        } catch (err) {
          console.error("Error fetching short leaves:", err);
        }
        setShortLeaves(normalizedShortLeaves);
        setShortLeavesCount(normalizedShortLeaves.length);

        // 2. Fetch Duty Leaves
        let normalizedDutyLeaves = [];
        try {
          const dutyData = await fetchDutyLeaves(userObj._id);
          if (dutyData && Array.isArray(dutyData.data)) {
            normalizedDutyLeaves = dutyData.data.map((leave) => ({
              ...leave,
              date: leave.date
                ? new Date(
                    Date.UTC(
                      new Date(leave.date).getUTCFullYear(),
                      new Date(leave.date).getUTCMonth(),
                      new Date(leave.date).getUTCDate()
                    )
                  )
                : null,
              document: leave.document,
            }));
          }
        } catch (err) {
          console.error("Error fetching duty leaves:", err);
        }
        setDutyLeaves(normalizedDutyLeaves);
        setDutyLeavesCount(normalizedDutyLeaves.length);

        // 3. Fetch Special Leaves
        let normalizedSpecialLeaves = [];
        try {
          const specialLeaveData = await fetchSpecialLeaves(userObj._id);
          if (specialLeaveData && Array.isArray(specialLeaveData.data)) {
            normalizedSpecialLeaves = specialLeaveData.data.map((leave) => ({
              ...leave,
              date: leave.date
                ? new Date(
                    Date.UTC(
                      new Date(leave.date).getUTCFullYear(),
                      new Date(leave.date).getUTCMonth(),
                      new Date(leave.date).getUTCDate()
                    )
                  )
                : null,
              document: leave.document,
            }));
          }
        } catch (err) {
          console.error("Error fetching special leaves:", err);
        }
        setSpecialLeaves(normalizedSpecialLeaves);
        setSpecialLeavesCount(normalizedSpecialLeaves.length);

        // 4. Fetch Maternity Leaves
        let normalizedMaternityLeaves = [];
        try {
          const maternityLeaveData = await fetchMaternityLeaves(userObj._id);
          if (maternityLeaveData && Array.isArray(maternityLeaveData.data)) {
            normalizedMaternityLeaves = maternityLeaveData.data.map(
              (leave) => ({
                ...leave,
                startDate: leave.startDate
                  ? new Date(
                      Date.UTC(
                        new Date(leave.startDate).getUTCFullYear(),
                        new Date(leave.startDate).getUTCMonth(),
                        new Date(leave.startDate).getUTCDate()
                      )
                    )
                  : null,
                endDate: leave.endDate
                  ? new Date(
                      Date.UTC(
                        new Date(leave.endDate).getUTCFullYear(),
                        new Date(leave.endDate).getUTCMonth(),
                        new Date(leave.endDate).getUTCDate()
                      )
                    )
                  : null,
                expectedDeliveryDate: leave.expectedDeliveryDate
                  ? new Date(
                      Date.UTC(
                        new Date(leave.expectedDeliveryDate).getUTCFullYear(),
                        new Date(leave.expectedDeliveryDate).getUTCMonth(),
                        new Date(leave.expectedDeliveryDate).getUTCDate()
                      )
                    )
                  : null,
                leaveDays: leave.leaveDays || [],
                document: leave.document,
              })
            );
          }
        } catch (err) {
          console.error("Error fetching maternity leaves:", err);
        }
        setMaternityLeaves(normalizedMaternityLeaves);
        setMaternityLeavesCount(normalizedMaternityLeaves.length);

        // 5. Fetch Authorized No Pay Leaves
        let normalizedAuthorizedNoPayLeaves = [];
        try {
          const authorizedNoPayData = await searchAuthorizedNoPayLeaves({
            userId: userObj._id,
          });
          if (authorizedNoPayData && Array.isArray(authorizedNoPayData.data)) {
            normalizedAuthorizedNoPayLeaves = authorizedNoPayData.data.map((item) => ({
              id: item._id,
              epf_number: item.employee?.epf_number || "N/A",
              name: item.employee?.full_name || "N/A",
              branch: item.employee?.branch || "N/A",
              department: item.department?.departmentName || "N/A",
              startDate: item.startDate
                ? new Date(
                    Date.UTC(
                      new Date(item.startDate).getUTCFullYear(),
                      new Date(item.startDate).getUTCMonth(),
                      new Date(item.startDate).getUTCDate()
                    )
                  )
                : null,
              endDate: item.endDate
                ? new Date(
                    Date.UTC(
                      new Date(item.endDate).getUTCFullYear(),
                      new Date(item.endDate).getUTCMonth(),
                      new Date(item.endDate).getUTCDate()
                    )
                  )
                : null,
              reason: item.reason || "N/A",
              document: item.document,
            }));
          }
        } catch (err) {
          console.error("Error fetching authorized no pay leaves:", err);
        }
        setAuthorizedNoPayLeaves(normalizedAuthorizedNoPayLeaves);
      } catch (err) {
        console.error("Error fetching leaves in main handler:", err);
        showNotification(
          "error",
          "Error",
          err.response?.data?.message || "Failed to fetch leaves."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchShortLeaveData();
  }, []);

  useEffect(() => {
    const fetchLeaves = async () => {
      // Skip default loading if coming from dashboard with filters
      if (dashboardState?.fromDashboard && dashboardState?.startDate && dashboardState?.endDate) {
        console.log('Skipping default load - will use dashboard filters');
        return;
      }
      
      try {
        const response = await getEmployeeLeaveWithEmployee(
          userObj._id,
          setLoading
        );
        const leaveData = response.data;
        setgroupedData(response.grp_data);

        if (leaveData) {
          const formattedData = leaveData.map((item) => ({
            id: item._id,
            empname: item.employee
              ? (item.employee.full_name || 
                 `${item.employee.first_name || ''} ${item.employee.last_name || ''}`.trim() || 
                 "N/A")
              : "N/A",
            empid: item.employee ? item.employee.employee_id : "N/A",
            epf: item.employee?.epf_number || "N/A",
            type: item.leavetype.name,
            attendanceType: item.attendanceType || "",
            fromdate: moment.utc(item.leaveDate).format("YYYY-MM-DD"),
            appliedon: moment.utc(item.appliedOn).format("YYYY-MM-DD"),
            status: item.approval,
            branch: item.employee?.branch || "N/A",
            coverupStatus: item.coverupStatus || "N/A",
            coverupEmployeeDetails: item.coverupEmployeeDetails || null,
            coverupEmployeeName: item.coverupEmployeeDetails?.full_name?.trim() || null,
            coverupEmployeeId: item.coverupEmployeeDetails?.employee_id || null,
            reason: item.reason || "N/A",
            document: item.document, // Include document field
          }));

          const sortedData = formattedData.sort(
            (a, b) => new Date(b.appliedon) - new Date(a.appliedon)
          );
          setDataSource(sortedData);
          setLeavesCount(countLeaves(sortedData));
          setSpecialLeavesCount(countSpecialLeaves(sortedData));
        }
      } catch (error) {
        console.error("Error fetching leaves:", error);
      }
    };
    fetchLeaves();
  }, []);

  // Handle navigation from dashboard with date filters
  useEffect(() => {
    if (dashboardState?.fromDashboard && startDate && endDate) {
      console.log('Dashboard navigation - triggering search with dates:', { 
        startDate, 
        endDate, 
        branch 
      });
      
      // Trigger search now that state is set
      const timer = setTimeout(() => {
        getSeachData();
      }, 500);
      
      // Clear navigation state to prevent re-triggering
      window.history.replaceState({}, document.title);
      
      return () => clearTimeout(timer);
    }
  }, [startDate, endDate, branch]);

  // Auto-search when name changes (minimum 3 characters)
  useEffect(() => {
    if (name.length >= 3) {
      const debounceTimer = setTimeout(() => {
        getSeachData();
      }, 500); // 500ms debounce delay

      return () => clearTimeout(debounceTimer);
    }
  }, [name, currentTab]);


  const countLeaves = (leaveData) => {
    return leaveData.filter(
      (item) =>
        item.type &&
        item.type.toLowerCase() !== "short leave" &&
        item.type.toLowerCase() !== "duty leave" &&
        item.type.toLowerCase() !== "special leave" &&
        item.type.toLowerCase() !== "maternity leave"
    ).length;
  };

  const countShortLeaves = (shortLeaveData) => {
    return shortLeaveData.length;
  };

  const countDutyLeaves = (dutyLeaveData) => {
    return dutyLeaveData.length;
  };

  const countSpecialLeaves = (leaveData) => {
    return leaveData.filter(
      (item) => item.type && item.type.toLowerCase().includes("special")
    ).length;
  };
  const countMaternityLeaves = (maternityLeaveData) => {
    return maternityLeaveData.length;
  };

  const getSeachData = async () => {
    try {
      if (currentTab === "1") {
        setLoading(true);
        const response = await getSearchResults({
          setLoading,
          epf_number,
          name,
          leaveType,
          branch,
          startDate,
          endDate,
          userId: userObj._id,
        });
        const leaveData = response;

        if (leaveData) {
          const formattedData = leaveData.map((item) => ({
            id: item._id,
            empname: item.employee
              ? (item.employee.full_name || 
                 `${item.employee.first_name || ''} ${item.employee.last_name || ''}`.trim() || 
                 "N/A")
              : "N/A",
            empid: item.employee ? item.employee.employee_id : "N/A",
            epf: item.employee?.epf_number || "N/A",
            type: item.leavetype.name,
            attendanceType: item.attendanceType || "",
            fromdate: moment.utc(item.leaveDate).format("YYYY-MM-DD"),
            appliedon: moment.utc(item.appliedOn).format("YYYY-MM-DD"),
            status: item.approval,
            branch: item.employee?.branch || "N/A",
            coverupStatus: item.coverupStatus || "N/A",
            coverupEmployeeDetails: item.coverupEmployeeDetails || null,
            coverupEmployeeName: item.coverupEmployeeDetails?.full_name?.trim() || null,
            coverupEmployeeId: item.coverupEmployeeDetails?.employee_id || null,
            reason: item.reason || "N/A",
            document: item.document, // Include document field
          }));

          setDataSource(
            formattedData.sort(
              (a, b) => new Date(b.appliedon) - new Date(a.appliedon)
            )
          );
          setLeavesCount(countLeaves(formattedData));
          setSpecialLeavesCount(countSpecialLeaves(formattedData));
        }
      } else if (currentTab === "2") {
        setLoading1(true);
        const response = await searchShortLeaves({
          setLoading1,
          epf_number,
          name,
          branch,
          startDate,
          endDate,
          userId: userObj._id,
        });
        const formattedData = response.map((item) => ({
          ...item,
          document: item.document, // Include document field
        }));
        setShortLeaves(formattedData);
        setShortLeavesCount(countShortLeaves(formattedData));
      } else if (currentTab === "3") {
        setLoading2(true);
        const response = await searchDutyLeaves({
          setLoading2,
          epf_number,
          name,
          branch,
          startDate,
          endDate,
          userId: userObj._id,
        });
        const formattedData = response.map((item) => ({
          ...item,
          document: item.document, // Include document field
        }));
        setDutyLeaves(formattedData);
        setDutyLeavesCount(countDutyLeaves(formattedData));
      } else if (currentTab === "4") {
        setLoading3(true);
        const response = await searchSpecialLeaves({
          setLoading3,
          epf_number,
          name,
          branch,
          startDate,
          endDate,
          userId: userObj._id,
        });
        const formattedData = response.map((item) => ({
          ...item,
          document: item.document, // Include document field
        }));
        setSpecialLeaves(formattedData);
        setSpecialLeavesCount(countSpecialLeaves(formattedData));
      } else if (currentTab === "5") {
        setLoading4(true);
        const response = await searchMaternityLeaves({
          setLoading4,
          epf_number,
          name,
          branch,
          startDate,
          endDate,
          userId: userObj._id,
        });
        const formattedData = response.map((item) => ({
          ...item,
          document: item.document,
        }));
        setMaternityLeaves(formattedData);
        setMaternityLeavesCount(countMaternityLeaves(formattedData));
      }
    else if (currentTab === "6") {
      setLoading5(false);
      const response = await searchAuthorizedNoPayLeaves({
        epf_number,
        name,
        branch,
        startDate,
        endDate,
        userId: userObj._id,
      });
      const formattedData = Array.isArray(response.data)
        ? response.data.map((item) => ({
            id: item._id,
            epf_number: item.employee?.epf_number || "N/A",
            name: item.employee?.full_name || "N/A",
            branch: item.employee?.branch || "N/A",
            department: item.department?.departmentName || "N/A",
            startDate: item.startDate
              ? new Date(
                  Date.UTC(
                    new Date(item.startDate).getUTCFullYear(),
                    new Date(item.startDate).getUTCMonth(),
                    new Date(item.startDate).getUTCDate()
                  )
                )
              : null,
            endDate: item.endDate
              ? new Date(
                  Date.UTC(
                    new Date(item.endDate).getUTCFullYear(),
                    new Date(item.endDate).getUTCMonth(),
                    new Date(item.endDate).getUTCDate()
                  )
                )
              : null,
            reason: item.reason || "N/A",
            document: item.document,
          }))
        : [];
      setAuthorizedNoPayLeaves(formattedData);
      if (formattedData.length === 0) {
        showNotification("warning", "No Data", "No authorized no pay leaves found for the selected filters.");
      }
    }
  } catch (error) {
    console.error("Error fetching leaves:", error);
    showNotification(
      "error",
      error.response?.data?.message || "Employee Leave not found!",
      ""
    );
  } finally {
    setLoading(false);
    setLoading1(false);
    setLoading2(false);
    setLoading3(false);
    setLoading4(false);
    setLoading5(false);
  }
};

      
  const handleStatusChange = (value, recordId) => {
    setDataSource((prevData) =>
      prevData.map((record) =>
        record.id === recordId ? { ...record, status: value } : record
      )
    );
  };

  const handleDutyStatusChange = (value, recordId) => {
    setDutyLeaves((prevData) =>
      prevData.map((record) =>
        record._id === recordId ? { ...record, approval: value } : record
      )
    );
  };

  const handleSpecialStatusChange = (value, recordId) => {
    setSpecialLeaves((prevData) =>
      prevData.map((record) =>
        record._id === recordId ? { ...record, approval: value } : record
      )
    );
  };

  const handleShortStatusChange = (value, recordId) => {
    setShortLeaves((prevData) =>
      prevData.map((record) =>
        record._id === recordId ? { ...record, approval: value } : record
      )
    );
  };

  const handleMaternityStatusChange = (value, recordId) => {
    setMaternityLeaves((prevData) =>
      prevData.map((record) =>
        record._id === recordId ? { ...record, approval: value } : record
      )
    );
  };

  const formatDate = (date) => {
    if (!date || isNaN(new Date(date).getTime())) {
      return "N/A";
    }
    return moment.utc(date).format("MM/DD/YYYY");
  };

const handleSelectChange = async (value, record) => {
  const updatedStatus = { ...tempStatus, [record.id]: value };
  setTempStatus(updatedStatus);

  // Fetch leave allocation for the employee
  let leaveBalancesHtml = "<div>No leave balances found for this employee.</div>";
  try {
    const leaveAllocation = await getLeaveAllocationByEmployeeId(record.empid);
    if (leaveAllocation && leaveAllocation.leaveBalances?.length > 0) {
      leaveBalancesHtml = `
        <div style="margin-bottom: 20px;">
          <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Leave Balances</h5>
          <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
            <thead>
              <tr style="background-color: #f0f0f0;">
                <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">Leave Type</th>
                <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">Initial Quota</th>
                <th style="padding: 8px; text-align: left; border: 1px solid #ddd;">Current Balance</th>
              </tr>
            </thead>
            <tbody>
              ${leaveAllocation.leaveBalances
                .map((balance) => {
                  return `
                    <tr>
                      <td style="padding: 8px; border: 1px solid #ddd;">${balance.leaveType.name || "Unknown"}</td>
                      <td style="padding: 8px; border: 1px solid #ddd;">${balance.initialQuota}</td>
                      <td style="padding: 8px; border: 1px solid #ddd;">${balance.currentBalance}</td>
                    </tr>
                  `;
                })
                .join("")}
            </tbody>
          </table>
        </div>
      `;
    }
  } catch (error) {
    console.error("Error fetching leave allocation:", error);
    leaveBalancesHtml = "<div>Error fetching leave balances.</div>";
  }

    Swal.fire({
      title: '<span style="font-size: 24px; font-weight: bold;">View Leave Request</span>',
      html: `
        <div style="text-align: left; font-family: Arial, sans-serif; padding: 20px;">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 20px;">
            <div style="display: flex; align-items: center;">
              <img src="path-to-employee-image.jpg" alt="Employee" style="width: 80px; height: 80px; border-radius: 10px; margin-right: 20px;" />
              <div>
                <h4 style="margin: 0; color: #333; font-size: 18px; font-weight: bold;">${record.empname}</h4>
                <p style="margin: 5px 0; color: #ff6200; font-size: 14px;">Start: ${record.fromdate}</p>
                <p style="margin: 5px 0; color: #ff6200; font-size: 14px;">End: ${record.todate || record.fromdate}</p>
                <p style="margin: 5px 0; color: #777; font-size: 14px; display:none"  >Apply date: ${record.applydate}</p>
              </div>
            </div>
            <div style="text-align: right;">
              <p style="margin: 5px 0; color: #777; font-size: 14px;">Emp No: ${record.empid}</p>
            </div>
          </div>
          <div style="margin-bottom: 20px;">
            <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Reason</h5>
            <p style="margin: 10px 0; color: #555; font-size: 14px; line-height: 1.5;">${record.reason || "No reason provided."}</p>
          </div>
          ${record.coverupEmployeeName ? `
            <div style="margin-bottom: 20px;">
              <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Cover-up Employee</h5>
              <p style="margin: 10px 0; color: #555; font-size: 14px; line-height: 1.5;">
                ${record.coverupEmployeeName}${record.coverupEmployeeId ? ` (${record.coverupEmployeeId})` : ""}
                ${record.coverupStatus ? `<br/><span style="color: #ff8c00; font-weight: 600;">Status: ${record.coverupStatus}</span>` : ""}
              </p>
            </div>
          ` : ""}
          <div style="margin-bottom: 20px;">
            <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Document</h5>
            <p style="margin: 10px 0; color: #555; font-size: 14px; line-height: 1.5;">
              ${
                record.document
                  ? `<a href="${getDocUrl(record.document)}" target="_blank" style="color: #007bff; text-decoration: underline;">View Document</a>`
                  : "No document uploaded."
              }
            </p>
          </div>
          ${leaveBalancesHtml}
        </div>
      `,
      showConfirmButton: false,
      showCancelButton: false,
      customClass: {
        popup: "custom-swal-popup",
      },
      buttonsStyling: false,
      footer: `
        <div style="display: flex; justify-content: space-between; width: 100%; padding: 10px;">
          <button id="swal-reject-btn" style="background-color: #dc3545; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; font-weight: bold; cursor: pointer;">Reject</button>
          <button id="swal-approve-btn" style="background-color: #28a745; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; font-weight: bold; cursor: pointer;">Approve</button>
        </div>
      `,
      didOpen: () => {
        document.getElementById("swal-reject-btn").addEventListener("click", () => {
          handleStatusChange(false, record.id);
          updateApprovalStatus(record.id, false);
          Swal.fire({
            title: "Rejected!",
            text: `Leave status has been updated to Rejected.`,
            icon: "success",
          });
          Swal.close();
        });

        document.getElementById("swal-approve-btn").addEventListener("click", () => {
          handleStatusChange(true, record.id);
          updateApprovalStatus(record.id, true);
          Swal.fire({
            title: "Approved!",
            text: `Leave status has been updated to Approved.`,
            icon: "success",
          });
          Swal.close();
        });
      },
    }).then((result) => {
      if (!result.isConfirmed && !result.isDismissed) {
        setTempStatus({ ...tempStatus, [record.id]: record.status });
      }
    });
  };

  const handleDutySelectChange = (value, record) => {
    const updatedStatus = { ...tempStatusduty, [record._id]: value };
    setTempdutyStatus(updatedStatus);

    Swal.fire({
      title:
        '<span style="font-size: 24px; font-weight: bold;">View Leave Request</span>',
      html: `
        <div style="text-align: left; font-family: Arial, sans-serif; padding: 20px;">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 20px;">
            <div style="display: flex; align-items: center;">
              <img src="path-to-employee-image.jpg" alt="Employee" style="width: 80px; height: 80px; border-radius: 10px; margin-right: 20px;" />
              <div>
                <h4 style="margin: 0; color: #333; font-size: 18px; font-weight: bold;">${
                  record.employee?.full_name || "N/A"
                }</h4>
                <p style="margin: 5px 0; color: #ff6200; font-size: 14px;">Date: ${formatDate(
                  record.date
                )}</p>
              </div>
            </div>
            <div style="text-align: right;">
              <p style="margin: 5px 0; color: #777; font-size: 14px;">Emp No: ${
                record.employee?.epf_number || "N/A"
              }</p>
            </div>
          </div>
          <div style="margin-bottom: 20px;">
            <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Reason</h5>
            <p style="margin: 10px 0; color: #555; font-size: 14px; line-height: 1.5;">${
              record.reason || "No reason provided."
            }</p>
          </div>
          <div style="margin-bottom: 20px;">
            <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Document</h5>
            <p style="margin: 10px 0; color: #555; font-size: 14px; line-height: 1.5;">
              ${
                record.document
                  ? `<a href="${getDocUrl(record.document)}" target="_blank" style="color: #007bff; text-decoration: underline;">View Document</a>`
                  : "No document uploaded."
              }
            </p>
          </div>
        </div>
      `,
      showConfirmButton: false,
      showCancelButton: false,
      customClass: {
        popup: "custom-swal-popup",
      },
      buttonsStyling: false,
      footer: `
        <div style="display: flex; justify-content: space-between; width: 100%; padding: 10px;">
          <button id="swal-reject-btn" style="background-color: #dc3545; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; font-weight: bold; cursor: pointer;">Reject</button>
          <button id="swal-approve-btn" style="background-color: #28a745; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; font-weight: bold; cursor: pointer;">Approve</button>
        </div>
      `,
      didOpen: () => {
        document
          .getElementById("swal-reject-btn")
          .addEventListener("click", () => {
            handleDutyStatusChange(false, record._id);
            updateApproval(record._id, false)
              .then(() => {
                Swal.fire({
                  title: "Rejected!",
                  text: `Leave status has been updated to Rejected.`,
                  icon: "success",
                });
                setTempdutyStatus({ ...tempStatusduty, [record._id]: false });
              })
              .catch((error) => {
                console.error("Error updating approval:", error);
                Swal.fire("Error", "Failed to update leave status.", "error");
              });
            Swal.close();
          });

        document
          .getElementById("swal-approve-btn")
          .addEventListener("click", () => {
            handleDutyStatusChange(true, record._id);
            updateApproval(record._id, true)
              .then(() => {
                Swal.fire({
                  title: "Approved!",
                  text: `Leave status has been updated to Approved.`,
                  icon: "success",
                });
                setTempdutyStatus({ ...tempStatusduty, [record._id]: true });
              })
              .catch((error) => {
                console.error("Error updating approval:", error);
                Swal.fire("Error", "Failed to update leave status.", "error");
              });
            Swal.close();
          });
      },
    }).then((result) => {
      if (!result.isConfirmed && !result.isDismissed) {
        setTempdutyStatus({ ...tempStatusduty, [record._id]: record.approval });
      }
    });
  };

  // Updated handleSpecialSelectChange
  const handleSpecialSelectChange = (value, record) => {
    const updatedStatus = { ...tempStatusSpecial, [record._id]: value };
    setTempSpecialStatus(updatedStatus);

    Swal.fire({
      title:
        '<span style="font-size: 24px; font-weight: bold;">View Leave Request</span>',
      html: `
        <div style="text-align: left; font-family: Arial, sans-serif; padding: 20px;">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 20px;">
            <div style="display: flex; align-items: center;">
              <img src="path-to-employee-image.jpg" alt="Employee" style="width: 80px; height: 80px; border-radius: 10px; margin-right: 20px;" />
              <div>
                <h4 style="margin: 0; color: #333; font-size: 18px; font-weight: bold;">${
                  record.employee?.full_name || "N/A"
                }</h4>
                <p style="margin: 5px 0; color: #ff6200; font-size: 14px;">Date: ${formatDate(
                  record.date
                )}</p>
              </div>
            </div>
            <div style="text-align: right;">
              <p style="margin: 5px 0; color: #777; font-size: 14px;">Emp No: ${
                record.employee?.epf_number || "N/A"
              }</p>
            </div>
          </div>
          <div style="margin-bottom: 20px;">
            <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Reason</h5>
            <p style="margin: 10px 0; color: #555; font-size: 14px; line-height: 1.5;">${
              record.reason || "No reason provided."
            }</p>
          </div>
          <div style="margin-bottom: 20px;">
            <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Document</h5>
            <p style="margin: 10px 0; color: #555; font-size: 14px; line-height: 1.5;">
              ${
                record.document
                  ? `<a href="${getDocUrl(record.document)}" target="_blank" style="color: #007bff; text-decoration: underline;">View Document</a>`
                  : "No document uploaded."
              }
            </p>
          </div>
        </div>
      `,
      showConfirmButton: false,
      showCancelButton: false,
      customClass: {
        popup: "custom-swal-popup",
      },
      buttonsStyling: false,
      footer: `
        <div style="display: flex; justify-content: space-between; width: 100%; padding: 10px;">
          <button id="swal-reject-btn" style="background-color: #dc3545; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; font-weight: bold; cursor: pointer;">Reject</button>
          <button id="swal-approve-btn" style="background-color: #28a745; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; font-weight: bold; cursor: pointer;">Approve</button>
        </div>
      `,
      didOpen: () => {
        document
          .getElementById("swal-reject-btn")
          .addEventListener("click", () => {
            handleSpecialStatusChange(false, record._id);
            updateSpecialApproval(record._id, false)
              .then(() => {
                Swal.fire({
                  title: "Rejected!",
                  text: `Leave status has been updated to Rejected.`,
                  icon: "success",
                });
                setTempSpecialStatus({
                  ...tempStatusSpecial,
                  [record._id]: false,
                });
              })
              .catch((error) => {
                console.error("Error updating approval:", error);
                Swal.fire("Error", "Failed to update leave status.", "error");
              });
            Swal.close();
          });

        document
          .getElementById("swal-approve-btn")
          .addEventListener("click", () => {
            handleSpecialStatusChange(true, record._id);
            updateSpecialApproval(record._id, true)
              .then(() => {
                Swal.fire({
                  title: "Approved!",
                  text: `Leave status has been updated to Approved.`,
                  icon: "success",
                });
                setTempSpecialStatus({
                  ...tempStatusSpecial,
                  [record._id]: true,
                });
              })
              .catch((error) => {
                console.error("Error updating approval:", error);
                Swal.fire("Error", "Failed to update leave status.", "error");
              });
            Swal.close();
          });
      },
    }).then((result) => {
      if (!result.isConfirmed && !result.isDismissed) {
        setTempSpecialStatus({
          ...tempStatusSpecial,
          [record._id]: record.approval,
        });
      }
    });
  };

  // Updated handleShortChange
  const handleShortChange = (value, record) => {
    const updatedStatus = { ...tempStatusShort, [record._id]: value };
    setTempShortStatus(updatedStatus);

    Swal.fire({
      title:
        '<span style="font-size: 24px; font-weight: bold;">View Leave Request</span>',
      html: `
        <div style="text-align: left; font-family: Arial, sans-serif; padding: 20px;">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 20px;">
            <div style="display: flex; align-items: center;">
              <img src="path-to-employee-image.jpg" alt="Employee" style="width: 80px; height: 80px; border-radius: 10px; margin-right: 20px;" />
              <div>
                <h4 style="margin: 0; color: #333; font-size: 18px; font-weight: bold;">${
                  record.employee?.full_name || "N/A"
                }</h4>
                <p style="margin: 5px 0; color: #ff6200; font-size: 14px;">Date: ${formatDate(
                  record.date
                )}</p>
                <p style="margin: 5px 0; color: #ff6200; font-size: 14px;">Time: ${
                  record.leave_time || "N/A"
                }</p>
              </div>
            </div>
            <div style="text-align: right;">
              <p style="margin: 5px 0; color: #777; font-size: 14px;">Emp No: ${
                record.employee?.epf_number || "N/A"
              }</p>
            </div>
          </div>
          <div style="margin-bottom: 20px;">
            <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Reason</h5>
            <p style="margin: 10px 0; color: #555; font-size: 14px; line-height: 1.5;">${
              record.reason || "No reason provided."
            }</p>
          </div>
          <div style="margin-bottom: 20px;">
            <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Document</h5>
            <p style="margin: 10px 0; color: #555; font-size: 14px; line-height: 1.5;">
              ${
                record.document
                  ? `<a href="${getDocUrl(record.document)}" target="_blank" style="color: #007bff; text-decoration: underline;">View Document</a>`
                  : "No document uploaded."
              }
            </p>
          </div>
        </div>
      `,
      showConfirmButton: false,
      showCancelButton: false,
      customClass: {
        popup: "custom-swal-popup",
      },
      buttonsStyling: false,
      footer: `
        <div style="display: flex; justify-content: space-between; width: 100%; padding: 10px;">
          <button id="swal-reject-btn" style="background-color: #dc3545; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; font-weight: bold; cursor: pointer;">Reject</button>
          <button id="swal-approve-btn" style="background-color: #28a745; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; font-weight: bold; cursor: pointer;">Approve</button>
        </div>
      `,
      didOpen: () => {
        document
          .getElementById("swal-reject-btn")
          .addEventListener("click", () => {
            handleShortStatusChange(false, record._id);
            updateShortApproval(record._id, false)
              .then(() => {
                Swal.fire({
                  title: "Rejected!",
                  text: `Leave status has been updated to Rejected.`,
                  icon: "success",
                });
                setTempShortStatus({ ...tempStatusShort, [record._id]: false });
              })
              .catch((error) => {
                console.error("Error updating approval:", error);
                Swal.fire("Error", "Failed to update leave status.", "error");
              });
            Swal.close();
          });

        document
          .getElementById("swal-approve-btn")
          .addEventListener("click", () => {
            handleShortStatusChange(true, record._id);
            updateShortApproval(record._id, true)
              .then(() => {
                Swal.fire({
                  title: "Approved!",
                  text: `Leave status has been updated to Approved.`,
                  icon: "success",
                });
                setTempShortStatus({ ...tempStatusShort, [record._id]: true });
              })
              .catch((error) => {
                console.error("Error updating approval:", error);
                Swal.fire("Error", "Failed to update leave status.", "error");
              });
            Swal.close();
          });
      },
    }).then((result) => {
      if (!result.isConfirmed && !result.isDismissed) {
        setTempShortStatus({
          ...tempStatusShort,
          [record._id]: record.approval,
        });
      }
    });
  };

  const handleMaternitySelectChange = (value, record) => {
    const updatedStatus = { ...tempStatusMaternity, [record._id]: value };
    setTempMaternityStatus(updatedStatus);

    Swal.fire({
      title:
        '<span style="font-size: 24px; font-weight: bold;">View Maternity Leave Request</span>',
      html: `
        <div style="text-align: left; font-family: Arial, sans-serif; padding: 20px;">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 20px;">
            <div style="display: flex; align-items: center;">
              <img src="path-to-employee-image.jpg" alt="Employee" style="width: 80px; height: 80px; border-radius: 10px; margin-right: 20px;" />
              <div>
                <h4 style="margin: 0; color: #333; font-size: 18px; font-weight: bold;">${
                  record.employee?.full_name || "N/A"
                }</h4>
                <p style="margin: 5px 0; color: #ff6200; font-size: 14px;">Start Date: ${formatDate(
                  record.startDate
                )}</p>
                <p style="margin: 5px 0; color: #ff6200; font-size: 14px;">End Date: ${formatDate(
                  record.endDate
                )}</p>
                <p style="margin: 5px 0; color: #ff6200; font-size: 14px;">Expected Delivery: ${formatDate(
                  record.expectedDeliveryDate
                )}</p>
              </div>
            </div>
            <div style="text-align: right;">
              <p style="margin: 5px 0; color: #777; font-size: 14px;">Emp No: ${
                record.employee?.epf_number || "N/A"
              }</p>
            </div>
          </div>
          <div style="margin-bottom: 20px;">
            <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Reason</h5>
            <p style="margin: 10px 0; color: #555; font-size: 14px; line-height: 1.5;">${
              record.reason || "No reason provided."
            }</p>
          </div>
          <div style="margin-bottom: 20px;">
            <h5 style="margin: 0; color: #333; font-size: 16px; font-weight: bold;">Document</h5>
            <p style="margin: 10px 0; color: #555; font-size: 14px; line-height: 1.5;">
              ${
                record.document
                  ? `<a href="${getDocUrl(record.document)}" target="_blank" style="color: #007bff; text-decoration: underline;">View Document</a>`
                  : "No document uploaded."
              }
            </p>
          </div>
        </div>
      `,
      showConfirmButton: false,
      showCancelButton: false,
      customClass: {
        popup: "custom-swal-popup",
      },
      buttonsStyling: false,
      footer: `
        <div style="display: flex; justify-content: space-between; width: 100%; padding: 10px;">
          <button id="swal-reject-btn" style="background-color: #dc3545; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; font-weight: bold; cursor: pointer;">Reject</button>
          <button id="swal-approve-btn" style="background-color: #28a745; color: white; padding: 12px 24px; border: none; border-radius: 8px; font-size: 16px; font-weight: bold; cursor: pointer;">Approve</button>
        </div>
      `,
      didOpen: () => {
        document
          .getElementById("swal-reject-btn")
          .addEventListener("click", () => {
            handleMaternityStatusChange(false, record._id);
            updateMaternityApprovalById(record._id, false)
              .then(() => {
                Swal.fire({
                  title: "Rejected!",
                  text: `Maternity leave status has been updated to Rejected.`,
                  icon: "success",
                });
                setTempMaternityStatus({
                  ...tempStatusMaternity,
                  [record._id]: false,
                });
              })
              .catch((error) => {
                console.error("Error updating approval:", error);
                Swal.fire("Error", "Failed to update leave status.", "error");
              });
            Swal.close();
          });

        document
          .getElementById("swal-approve-btn")
          .addEventListener("click", () => {
            handleMaternityStatusChange(true, record._id);
            updateMaternityApprovalById(record._id, true)
              .then(() => {
                Swal.fire({
                  title: "Approved!",
                  text: `Maternity leave status has been updated to Approved.`,
                  icon: "success",
                });
                setTempMaternityStatus({
                  ...tempStatusMaternity,
                  [record._id]: true,
                });
              })
              .catch((error) => {
                console.error("Error updating approval:", error);
                Swal.fire("Error", "Failed to update leave status.", "error");
              });
            Swal.close();
          });
      },
    }).then((result) => {
      if (!result.isConfirmed && !result.isDismissed) {
        setTempMaternityStatus({
          ...tempStatusMaternity,
          [record._id]: record.approval,
        });
      }
    });
  };

  const menu = (
    <Menu onClick={(e) => handleFileDownload(e.key)}>
      
      <Menu.Item key="etf-file">
        <div style={{ display: "flex", alignItems: "center" }}>
          <label className="btn" style={{ marginRight: "4px" }}>
            Leave Report
          </label>
          <img src="assets/img/icons/excel.svg" alt="excel" />
        </div>
      </Menu.Item>
      <Menu.Item key="epf-file">
        <div style={{ display: "flex", alignItems: "center" }}>
          <label className="btn" style={{ marginRight: "4px" }}>
            Leave Count Report
          </label>
          <img src="assets/img/icons/excel.svg" alt="excel" />
        </div>
      </Menu.Item>
    </Menu>
  );

  const handleFileDownload = (value) => {
    switch (value) {
      case "okids-payrolls":
        handlePdfExport();
        break;
      case "payrolls":
        handleCountPdfExport();
        break;
      case "etf-file":
        handleExcelExport();
        break;
      case "epf-file":
        handleCountExcelExport();
        break;
      default:
        break;
    }
  };

  const handlePdfExport = () => {
    const date = dayjs().format("YYYY-MM-DD");
    const img = okilogo;
    const filteredData = dataSource.map((emp) => ({
      name: `${emp.empname}`,
      number: emp.empid,
      applydate: new Date(emp.appliedon).toLocaleDateString(),
      type: emp.type,
      from: new Date(emp.fromdate).toLocaleDateString(),
      to: emp.todate || new Date(emp.fromdate).toLocaleDateString(),
      coverupStatus: emp.coverupStatus,
      status:
        emp.status === true
          ? "Approved"
          : emp.status === false
          ? "Rejected"
          : "Pending",
      document: emp.document || "N/A",
    }));

    const doc = new jsPDF();
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(16);
    doc.text("OKI International ", 15, 13);
    doc.setFontSize(13);
    doc.setTextColor(138, 132, 125);
    doc.text(`Employees Leaves`, 15, 23);
    doc.text(`Date: ${date}`, 15, 30);
    doc.addImage(img, "PNG", 170, 8, 22, 25);
    doc.autoTable({
      head: [
        [
          "Employee Name",
          "Employee Number",
          "Applied On",
          "Leave Type",
          "From",
          "To",
          "Coverup Status",
          "Status",
          "Document",
        ],
      ],
      body: filteredData.map((data) => [
        data.name,
        data.number,
        data.applydate,
        data.type,
        data.from,
        data.to,
        data.coverupStatus,
        data.status,
        data.document,
      ]),
      startY: 35,
      theme: " Striped",
      headStyles: {
        fillColor: [138, 132, 125],
      },
    });
    doc.save("employees_leaves.pdf");
  };

  const handleExcelExport = () => {
    const workbook = new ExcelJS.Workbook();
    let worksheetName = "Employees Leaves Report";
    let fileName = "Employees_Leaves_Report.xlsx";
    
    let columns = [];
    let rows = [];

    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    if (currentTab === "1") {
      worksheetName = "Regular Leaves Report";
      fileName = "Regular_Leaves_Report.xlsx";
      columns = [
        { header: "EPF No", key: "epf", width: 15 },
        { header: "Employee Name", key: "name", width: 25 },
        { header: "Branch", key: "branch", width: 20 },
        { header: "Leave Type", key: "type", width: 20 },
        { header: "Duration", key: "duration", width: 15 },
        { header: "Leave Date", key: "leaveDate", width: 15 },
        { header: "Applied On", key: "appliedOn", width: 15 },
        { header: "Coverup Employee", key: "coverupEmployee", width: 25 },
        { header: "Coverup Status", key: "coverupStatus", width: 20 },
        { header: "Status", key: "status", width: 15 },
      ];
      rows = dataSource.map((emp) => ({
        epf: emp.epf || "N/A",
        name: emp.empname || "N/A",
        branch: emp.branch || "N/A",
        type: emp.type || "N/A",
        duration: formatAttendanceTypeLabel(emp.attendanceType),
        leaveDate: emp.fromdate || "N/A",
        appliedOn: emp.appliedon || "N/A",
        coverupEmployee: buildCoverupName(emp),
        coverupStatus: emp.coverupStatus || "N/A",
        status: emp.status === true ? "Approved" : emp.status === false ? "Rejected" : "Pending",
      }));
    } else if (currentTab === "2") {
      worksheetName = "Short Leaves Report";
      fileName = "Short_Leaves_Report.xlsx";
      columns = [
        { header: "EPF No", key: "epf", width: 15 },
        { header: "Employee Name", key: "name", width: 25 },
        { header: "Branch", key: "branch", width: 20 },
        { header: "Time", key: "time", width: 15 },
        { header: "Date", key: "date", width: 15 },
        { header: "Applied On", key: "appliedOn", width: 15 },
        { header: "Status", key: "status", width: 15 },
      ];
      rows = shortLeaves.map((emp) => ({
        epf: emp.employee?.epf_number || "N/A",
        name: emp.employee?.full_name || "N/A",
        branch: emp.employee?.branch || "N/A",
        time: emp.leave_time || "N/A",
        date: emp.date ? new Date(emp.date).toISOString().split("T")[0] : "N/A",
        appliedOn: emp.appliedOn ? new Date(emp.appliedOn).toISOString().split("T")[0] : "N/A",
        status: emp.approval === true ? "Approved" : emp.approval === false ? "Rejected" : "Pending",
      }));
    } else if (currentTab === "3") {
      worksheetName = "Duty Leaves Report";
      fileName = "Duty_Leaves_Report.xlsx";
      columns = [
        { header: "EPF No", key: "epf", width: 15 },
        { header: "Employee Name", key: "name", width: 25 },
        { header: "Branch", key: "branch", width: 20 },
        { header: "Date", key: "date", width: 15 },
        { header: "Reason", key: "reason", width: 30 },
        { header: "Applied On", key: "appliedOn", width: 15 },
        { header: "Status", key: "status", width: 15 },
      ];
      rows = dutyLeaves.map((emp) => ({
        epf: emp.employee?.epf_number || "N/A",
        name: emp.employee?.full_name || "N/A",
        branch: emp.employee?.branch || "N/A",
        date: emp.date ? new Date(emp.date).toISOString().split("T")[0] : "N/A",
        reason: emp.reason || "N/A",
        appliedOn: emp.appliedOn ? new Date(emp.appliedOn).toISOString().split("T")[0] : "N/A",
        status: emp.approval === true ? "Approved" : emp.approval === false ? "Rejected" : "Pending",
      }));
    } else if (currentTab === "4") {
      worksheetName = "Special Leaves Report";
      fileName = "Special_Leaves_Report.xlsx";
      columns = [
        { header: "EPF No", key: "epf", width: 15 },
        { header: "Employee Name", key: "name", width: 25 },
        { header: "Branch", key: "branch", width: 20 },
        { header: "Date", key: "date", width: 15 },
        { header: "Reason", key: "reason", width: 30 },
        { header: "Applied On", key: "appliedOn", width: 15 },
        { header: "Status", key: "status", width: 15 },
      ];
      rows = specialLeaves.map((emp) => ({
        epf: emp.employee?.epf_number || "N/A",
        name: emp.employee?.full_name || "N/A",
        branch: emp.employee?.branch || "N/A",
        date: emp.date ? new Date(emp.date).toISOString().split("T")[0] : "N/A",
        reason: emp.reason || "N/A",
        appliedOn: emp.appliedOn ? new Date(emp.appliedOn).toISOString().split("T")[0] : "N/A",
        status: emp.approval === true ? "Approved" : emp.approval === false ? "Rejected" : "Pending",
      }));
    } else if (currentTab === "5") {
      worksheetName = "Maternity Leaves Report";
      fileName = "Maternity_Leaves_Report.xlsx";
      columns = [
        { header: "EPF No", key: "epf", width: 15 },
        { header: "Employee Name", key: "name", width: 25 },
        { header: "Branch", key: "branch", width: 20 },
        { header: "Start Date", key: "startDate", width: 15 },
        { header: "End Date", key: "endDate", width: 15 },
        { header: "Expected Delivery Date", key: "expectedDelivery", width: 20 },
        { header: "Reason", key: "reason", width: 30 },
        { header: "Applied On", key: "appliedOn", width: 15 },
        { header: "Status", key: "status", width: 15 },
      ];
      rows = maternityLeaves.map((emp) => ({
        epf: emp.employee?.epf_number || "N/A",
        name: emp.employee?.full_name || "N/A",
        branch: emp.employee?.branch || "N/A",
        startDate: emp.startDate ? new Date(emp.startDate).toISOString().split("T")[0] : "N/A",
        endDate: emp.endDate ? new Date(emp.endDate).toISOString().split("T")[0] : "N/A",
        expectedDelivery: emp.expectedDeliveryDate ? new Date(emp.expectedDeliveryDate).toISOString().split("T")[0] : "N/A",
        reason: emp.reason || "N/A",
        appliedOn: emp.appliedOn ? new Date(emp.appliedOn).toISOString().split("T")[0] : "N/A",
        status: emp.approval === true ? "Approved" : emp.approval === false ? "Rejected" : "Pending",
      }));
    } else if (currentTab === "6") {
      worksheetName = "Authorized No Pay Leaves Report";
      fileName = "Authorized_No_Pay_Leaves_Report.xlsx";
      columns = [
        { header: "EPF No", key: "epf", width: 15 },
        { header: "Employee Name", key: "name", width: 25 },
        { header: "Branch", key: "branch", width: 20 },
        { header: "Start Date", key: "startDate", width: 15 },
        { header: "End Date", key: "endDate", width: 15 },
        { header: "Reason", key: "reason", width: 30 },
      ];
      rows = authorizedNoPayLeaves.map((emp) => ({
        epf: emp.epf_number || "N/A",
        name: emp.name || "N/A",
        branch: emp.branch || "N/A",
        startDate: emp.startDate ? new Date(emp.startDate).toISOString().split("T")[0] : "N/A",
        endDate: emp.endDate ? new Date(emp.endDate).toISOString().split("T")[0] : "N/A",
        reason: emp.reason || "N/A",
      }));
    }

    const worksheet = workbook.addWorksheet(worksheetName);
    worksheet.columns = columns;

    rows.forEach((row) => {
      worksheet.addRow(row);
    });

    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = borderStyle;
      });
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  };

  const handleCountPdfExport = () => {
    const date = dayjs().format("YYYY-MM-DD");
    const img = okilogo;
    const filteredData = groupedData.map((emp) => ({
      name: `${emp.full_name}`,
      epf: emp.epf_number,
      branch: emp.branch,
      count: emp.count,
    }));

    const doc = new jsPDF();
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(16);
    doc.text("OKI International ", 15, 13);
    doc.setFontSize(13);
    doc.setTextColor(138, 132, 125);
    doc.text(`Employees Leaves`, 15, 23);
    doc.text(`Date: ${date}`, 15, 30);
    doc.addImage(img, "PNG", 170, 8, 22, 25);
    doc.autoTable({
      head: [["Employee Name", "EPF Number", "Branch", "Count"]],
      body: filteredData.map((data) => [
        data.name,
        data.epf,
        data.branch,
        data.count,
      ]),
      startY: 35,
      theme: "striped",
      headStyles: {
        fillColor: [138, 132, 125],
      },
    });
    doc.save("employees_leaves_count.pdf");
  };

  const handleCountExcelExport = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Employees Leaves Count Report");
    const borderStyle = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    worksheet.columns = [
      { header: "Emp Name", key: "name", width: 20 },
      { header: "EPF Number", key: "epf", width: 20 },
      { header: "Branch", key: "branch", width: 15 },
      { header: "Count", key: "count", width: 30 },
    ];

    groupedData.forEach((emp) => {
      worksheet.addRow({
        name: `${emp.full_name}`,
        epf: emp.epf_number,
        branch: emp.branch,
        count: emp.count,
      });
    });

    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.border = borderStyle;
      });
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Employees_Leaves_Count_Report.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "empname",
    },
    {
      title: "EPF",
      dataIndex: "epf",
    },
    {
      title: "Branch",
      dataIndex: "branch",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Duration",
      dataIndex: "attendanceType",
      render: (attendanceType) => formatAttendanceTypeLabel(attendanceType),
    },
    {
      title: "Leave Date",
      dataIndex: "fromdate",
    },
    {
      title: "Applied",
      dataIndex: "appliedon",
    },
    {
      title: "Coverup Employee",
      dataIndex: "coverupEmployeeName",
      render: (_, record) => buildCoverupName(record),
    },
    {
      title: "Coverup Status",
      dataIndex: "coverupStatus",
      render: (coverupStatus) => {
        let color, text;
        switch (coverupStatus) {
          case "ACCEPTED":
            color = "green";
            text = "Accepted";
            break;
          case "REJECTED":
            color = "red";
            text = "Rejected";
            break;
          case "PENDING":
            color = "orange";
            text = "Pending";
            break;
          default:
            color = "gray";
            text = "N/A";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: "Document",
      dataIndex: "document",
      render: (document) =>
        document ? (
          <Button
            type="primary"
            size="small"
            onClick={() => handleViewDocument(document)}
          >
            View
          </Button>
        ) : (
          "N/A"
        ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <Select
          value={
            tempStatus[record.id] !== undefined ? tempStatus[record.id] : status
          }
          onChange={(value) => handleSelectChange(value, record)}
          dropdownStyle={{ maxHeight: 200, overflowY: "auto", zIndex: 1050 }}
          getPopupContainer={(trigger) => trigger.parentNode}
          style={{ width: 120, height: 37 }}
          placeholder={status === null ? "Select" : undefined}
        >
          <Option value={null}>
            <Tag
              className="badges"
              style={{ color: "#f0ad4e", background: "none", border: "none" }}
            >
              Pending
            </Tag>
          </Option>
          <Option value={true}>
            <Tag
              className="badges status-badge"
              style={{ color: "green", background: "none", border: "none" }}
            >
              Approved
            </Tag>
          </Option>
          <Option value={false}>
            <Tag
              className="badges unstatus-badge"
              style={{ color: "red", background: "none", border: "none" }}
            >
              Rejected
            </Tag>
          </Option>
        </Select>
      ),
    },
  ];
  const columns1 = [
    {
      title: "EPF",
      dataIndex: "employee",
      render: (employee) => employee?.epf_number || "N/A",
    },
    {
      title: "Name",
      dataIndex: "employee",
      render: (employee) => employee?.full_name || "N/A",
    },
    {
      title: "Branch",
      dataIndex: "employee",
      render: (employee) => employee?.branch || "N/A",
    },
    {
      title: "Time",
      dataIndex: "leave_time",
      key: "leave_time",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) =>
        date ? new Date(date).toISOString().split("T")[0] : "N/A",
    },
   {
  title: "Applied",
  dataIndex: "appliedOn",
  key: "appliedOn",
  render: (appliedOn) =>
    appliedOn ? new Date(appliedOn).toISOString().split("T")[0] : "N/A",
},
    
    {
      title: "Document",
      dataIndex: "document",
      render: (document) =>
        document ? (
          <Button
            type="primary"
            size="small"
            onClick={() => handleViewDocument(document)}
          >
            View
          </Button>
        ) : (
          "N/A"
        ),
    },
    {
      title: "Status",
      dataIndex: "approval",
      key: "approval",
      render: (approval, record) => (
        <Select
          value={
            tempStatusShort[record._id] !== undefined
              ? tempStatusShort[record._id]
              : approval
          }
          onChange={(value) => handleShortChange(value, record)}
          dropdownStyle={{ maxHeight: 200, overflowY: "auto", zIndex: 1050 }}
          getPopupContainer={(trigger) => trigger.parentNode}
          style={{ width: 120, height: 37 }}
          placeholder={approval === null ? "Select" : undefined}
        >
          <Option value={null}>
            <Tag
              className="badges"
              style={{ color: "#f0ad4e", background: "none", border: "none" }}
            >
              Pending
            </Tag>
          </Option>
          <Option value={true}>
            <Tag
              className="badges status-badge"
              style={{ color: "green", background: "none", border: "none" }}
            >
              Approved
            </Tag>
          </Option>
          <Option value={false}>
            <Tag
              className="badges unstatus-badge"
              style={{ color: "red", background: "none", border: "none" }}
            >
              Rejected
            </Tag>
          </Option>
        </Select>
      ),
    },
  ];

  const columns2 = [
    {
      title: "EPF",
      dataIndex: "employee",
      render: (employee) => employee?.epf_number || "N/A",
    },
    {
      title: "Name",
      dataIndex: "employee",
      render: (employee) => employee?.full_name || "N/A",
    },
    {
      title: "Branch",
      dataIndex: "employee",
      render: (employee) => employee?.branch || "N/A",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) =>
        date ? new Date(date).toISOString().split("T")[0] : "N/A",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      render: (reason) => (
        <Popover content={reason}>
          <Button type="link">View</Button>
        </Popover>
      ),
    },
           {
  title: "Applied",
  dataIndex: "appliedOn",
  key: "appliedOn",
  render: (appliedOn) =>
    appliedOn ? new Date(appliedOn).toISOString().split("T")[0] : "N/A",
},
    {
      title: "Document",
      dataIndex: "document",
      render: (document) =>
        document ? (
          <Button
            type="primary"
            size="small"
            onClick={() => handleViewDocument(document)}
          >
            View
          </Button>
        ) : (
          "N/A"
        ),
    },
    {
      title: "Status",
      dataIndex: "approval",
      key: "approval",
      render: (approval, record) => (
        <Select
          value={
            tempStatusduty[record._id] !== undefined
              ? tempStatusduty[record._id]
              : approval
          }
          onChange={(value) => handleDutySelectChange(value, record)}
          dropdownStyle={{ maxHeight: 200, overflowY: "auto", zIndex: 1050 }}
          getPopupContainer={(trigger) => trigger.parentNode}
          style={{ width: 120, height: 37 }}
          placeholder={approval === null ? "Select" : undefined}
        >
          <Option value={null}>
            <Tag
              className="badges"
              style={{ color: "#f0ad4e", background: "none", border: "none" }}
            >
              Pending
            </Tag>
          </Option>
          <Option value={true}>
            <Tag
              className="badges status-badge"
              style={{ color: "green", background: "none", border: "none" }}
            >
              Approved
            </Tag>
          </Option>
          <Option value={false}>
            <Tag
              className="badges unstatus-badge"
              style={{ color: "red", background: "none", border: "none" }}
            >
              Rejected
            </Tag>
          </Option>
        </Select>
      ),
    },
  ];

  const columns3 = [
    {
      title: "EPF No",
      dataIndex: "employee",
      render: (employee) => employee?.epf_number || "N/A",
    },
    {
      title: "Emp Name",
      dataIndex: "employee",
      render: (employee) => employee?.full_name || "N/A",
    },
    {
      title: "Branch",
      dataIndex: "employee",
      render: (employee) => employee?.branch || "N/A",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) =>
        date ? new Date(date).toISOString().split("T")[0] : "N/A",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      render: (reason) => (
        <Popover content={reason}>
          <Button type="link">View</Button>
        </Popover>
      ),
    },
           {
  title: "Applied",
  dataIndex: "appliedOn",
  key: "appliedOn",
  render: (appliedOn) =>
    appliedOn ? new Date(appliedOn).toISOString().split("T")[0] : "N/A",
},
    {
      title: "Document",
      dataIndex: "document",
      render: (document) =>
        document ? (
          <Button
            type="primary"
            size="small"
            onClick={() => handleViewDocument(document)}
          >
            View
          </Button>
        ) : (
          "N/A"
        ),
    },
    {
      title: "Status",
      dataIndex: "approval",
      key: "approval",
      render: (approval, record) => (
        <Select
          value={
            tempStatusSpecial[record._id] !== undefined
              ? tempStatusSpecial[record._id]
              : approval
          }
          onChange={(value) => handleSpecialSelectChange(value, record)}
          dropdownStyle={{ maxHeight: 200, overflowY: "auto", zIndex: 1050 }}
          getPopupContainer={(trigger) => trigger.parentNode}
          style={{ width: 120, height: 37 }}
          placeholder={approval === null ? "Select" : undefined}
        >
          <Option value={null}>
            <Tag
              className="badges"
              style={{ color: "#f0ad4e", background: "none", border: "none" }}
            >
              Pending
            </Tag>
          </Option>
          <Option value={true}>
            <Tag
              className="badges status-badge"
              style={{ color: "green", background: "none", border: "none" }}
            >
              Approved
            </Tag>
          </Option>
          <Option value={false}>
            <Tag
              className="badges unstatus-badge"
              style={{ color: "red", background: "none", border: "none" }}
            >
              Rejected
            </Tag>
          </Option>
        </Select>
      ),
    },
  ];

  const columns4 = [
    {
      title: "EPF No",
      dataIndex: "employee",
      render: (employee) => employee?.epf_number || "N/A",
    },
    {
      title: "Emp Name",
      dataIndex: "employee",
      render: (employee) => employee?.full_name || "N/A",
    },
    {
      title: "Branch",
      dataIndex: "employee",
      render: (employee) => employee?.branch || "N/A",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      render: (startDate) =>
        startDate ? new Date(startDate).toISOString().split("T")[0] : "N/A",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      render: (endDate) =>
        endDate ? new Date(endDate).toISOString().split("T")[0] : "N/A",
    },
    {
      title: "Expected Delivery",
      dataIndex: "expectedDeliveryDate",
      render: (expectedDeliveryDate) =>
        expectedDeliveryDate
          ? new Date(expectedDeliveryDate).toISOString().split("T")[0]
          : "N/A",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      render: (reason) => (
        <Popover content={reason}>
          <Button type="link">View</Button>
        </Popover>
      ),
    },
           {
  title: "Applied",
  dataIndex: "appliedOn",
  key: "appliedOn",
  render: (appliedOn) =>
    appliedOn ? new Date(appliedOn).toISOString().split("T")[0] : "N/A",
},
    {
      title: "Document",
      dataIndex: "document",
      render: (document) =>
        document ? (
          <Button
            type="primary"
            size="small"
            onClick={() => handleViewDocument(document)}
          >
            View
          </Button>
        ) : (
          "N/A"
        ),
    },
    {
      title: "Status",
      dataIndex: "approval",
      key: "approval",
      render: (approval, record) => (
        <Select
          value={
            tempStatusMaternity[record._id] !== undefined
              ? tempStatusMaternity[record._id]
              : approval
          }
          onChange={(value) => handleMaternitySelectChange(value, record)}
          dropdownStyle={{ maxHeight: 200, overflowY: "auto", zIndex: 1050 }}
          getPopupContainer={(trigger) => trigger.parentNode}
          style={{ width: 120, height: 37 }}
          placeholder={approval === null ? "Select" : undefined}
        >
          <Option value={null}>
            <Tag
              className="badges"
              style={{ color: "#f0ad4e", background: "none", border: "none" }}
            >
              Pending
            </Tag>
          </Option>
          <Option value={true}>
            <Tag
              className="badges status-badge"
              style={{ color: "green", background: "none", border: "none" }}
            >
              Approved
            </Tag>
          </Option>
          <Option value={false}>
            <Tag
              className="badges unstatus-badge"
              style={{ color: "red", background: "none", border: "none" }}
            >
              Rejected
            </Tag>
          </Option>
        </Select>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="link" onClick={() => handleAdjustDate(record)}>
            <i data-feather="download" className="feather-edit"></i>
        </Button>
      ),
    },
  ];

  const columns5 = [
  {
    title: "EPF No",
    dataIndex: "epf_number",
    render: (text) => text || "N/A",
  },
  {
    title: "Emp Name",
    dataIndex: "name",
    render: (text) => text || "N/A",
  },
  {
    title: "Branch",
    dataIndex: "branch",
    render: (text) => text || "N/A",
  },
  {
    title: "Start Date",
    dataIndex: "startDate",
    render: (startDate) =>
      startDate ? new Date(startDate).toISOString().split("T")[0] : "N/A",
  },
  {
    title: "End Date",
    dataIndex: "endDate",
    render: (endDate) =>
      endDate ? new Date(endDate).toISOString().split("T")[0] : "N/A",
  },
  {
    title: "Reason",
    dataIndex: "reason",
    render: (reason) => (
      <Popover content={reason}>
        <Button type="link">View</Button>
      </Popover>
    ),
  },
  {
    title: "Document",
    dataIndex: "document",
    render: (document) =>
      document ? (
        <Button
          type="primary"
          size="small"
          onClick={() => handleViewDocument(document)}
        >
          View
        </Button>
      ) : (
        "N/A"
      ),
  },
];


  const leaveChartConfig = {
    series: [
      leavesCount,
      shortLeavesCount,
      dutyLeavesCount,
      specialLeavesCount,
      maternityLeavesCount,
    ],
    options: {
      chart: { type: "donut" },
      colors: ["#00E396", "#FF4560", "#8e35ff", "#ff9619", "#008FFB"],
      labels: [
        "Regular Leaves",
        "Short Leaves",
        "Duty Leaves",
        "Special Leaves",
        "Maternity Leaves",
      ],
      dataLabels: { enabled: false },
      legend: { show: false },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { width: 200 },
            legend: { position: "bottom" },
          },
        },
      ],
    },
  };

  const leavesMenu = (
  <Menu onClick={(e) => handleLeavesMenuClick(e)} style={{backgroundColor: '#ffe0b5ff'}} >
    <Menu.Item key="1" >Maternity</Menu.Item>
    <Menu.Item key="2">Authorized No Pay Leave</Menu.Item>
  </Menu>
);

// Handle clicks on the Add Leaves dropdown
const handleLeavesMenuClick = ({ key }) => {
  switch (key) {
    case '1':
      console.log('Maternity selected');
      setIsAddMaternityModalOpen(true); // Open maternity modal
      break;
    case '2':
      console.log('Authorized No Pay Leave selected');
             setAddModalVisible(true);

      break;
    default:
      break;
  }
};

  return (
   <div>
      {contextHolder}
      <div className="page-wrapper-lt">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="header-leave-container">
                <div>
                  <ArrowLeft size={32} />
                </div>
                <div className="page-title">
                  <h4>Admin Leaves</h4>
                  <h6>Manage your Leaves</h6>
                </div>
              </div>
            </div>

            <div className="wordset" style={{ marginLeft: "auto" }}>
              <ul>
                {/* Download Files Dropdown */}
                <li>
                  <Dropdown
                    overlay={menu}
                    trigger={["click"]}
                    placement="bottomLeft"
                  >
                    <Button style={{ width: 200, height: 35 }}>
                      Download Files <DownOutlined />
                    </Button>
                  </Dropdown>
                </li>

                {/* Add Leaves Dropdown */}
                <li>
  <Dropdown
    overlay={leavesMenu}
    trigger={["click"]}
    placement="bottomLeft"
  >
    <Button style={{ 
      width: 200, 
      height: 35,
      backgroundColor: '#ff9500', // Add your desired color
      color: 'white' // Optional: change text color if needed
    }}>
      Add Leaves <DownOutlined />
    </Button>
  </Dropdown>
</li>

                {/* Bulk Upload Button */}
                <div className="page-btn">
                  <a
                    className="btn btn-added-grid"
                    onClick={() => setIsBulkUploadOpen(true)}
                  >
                    Bulk Upload
                  </a>
                </div>


                {/* Allocated Leaves Button (unchanged) */}
                {user?.permissions &&
                  hasPermission(
                    user.permissions,
                    "HRM",
                    "Leaves",
                    "approve",
                    "Admin Leaves"
                  ) && (
                    <div className="page-btn">
                      <Link to="/allocate-leaves" className="btn btn-added">
                        Allocated Leaves
                      </Link>
                    </div>
                  )}
              </ul>
            </div>
          </div>

          <div className="row row1">
            <div className="col-3 col-d">
              <div className="card table-list-card-lt">
                <div
                  className="container mt-3 "
                  style={{
                    maxWidth: "100%",
                    marginLeft: "20px",
                    marginRight: "40px",
                  }}
                >
                  <h3 className="lt_chart_title">Available Leaves</h3>

                  <div className="leave-stats1">
                    <ReactApexChart
                      options={leaveChartConfig.options}
                      series={leaveChartConfig.series}
                      type="donut"
                      height={300}
                    />
                    <div className="custom-labels">
                      <div className="label-item">
                        <span
                          className="label-color"
                          style={{ backgroundColor: "#00E396" }}
                        ></span>
                        <span className="label-text">
                          Leaves: {leavesCount}
                        </span>
                      </div>
                      <div className="label-item">
                        <span
                          className="label-color"
                          style={{ backgroundColor: "#FF4560" }}
                        ></span>
                        <span className="label-text">
                          Short: {shortLeavesCount}
                        </span>
                      </div>
                      <div className="label-item">
                        <span
                          className="label-color"
                          style={{ backgroundColor: "#8e35ff" }}
                        ></span>
                        <span className="label-text">
                          Duty: {dutyLeavesCount}
                        </span>
                      </div>
                      <div className="label-item">
                        <span
                          className="label-color"
                          style={{ backgroundColor: "#ff9619" }}
                        ></span>
                        <span className="label-text">
                          Special: {specialLeavesCount}
                        </span>
                      </div>
                      <div className="label-item">
                        <span
                          className="label-color"
                          style={{ backgroundColor: "#008FFB" }}
                        ></span>
                        <span className="label-text">
                          Maternity: {maternityLeavesCount}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-9 col-dd">
              <style>
                {`
      @media (max-width: 767px) {
        .col-dd {
          padding: 15px !important;
        }
      }
    `}
              </style>

              <div className="card table-list-card-grid">
                <div
                  className="card-body"
                  style={{ maxWidth: "100%", marginRight: "20px" }}
                >
                  <div
                    className="container mt-3 "
                    style={{
                      maxWidth: "100%",
                      marginLeft: "20px",
                      marginRight: "40px",
                    }}
                  >
                    {" "}
                    <div className="row d-flex flex-wrap align-items-start justify-content-between">
                      {" "}
                      <div className="col-12 col-md-3  text-start">
                        <label className="form-label">Employee Name</label>
                        <input
                          type="text"
                          value={name}
                          className="form-control"
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-12 col-md-2 mb-3 text-start">
                        <label className="form-label">EPF No</label>
                        <input
                          className="form-control"
                          type="text"
                          value={epf_number}
                          onChange={(e) => setEpf(e.target.value)}
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-12 col-md-2 mb-3 text-start">
                        <label className="form-label">Leave Type</label>
                        <input
                          className="form-control"
                          type="text"
                          value={leaveType}
                          onChange={(e) => setLeaveType(e.target.value)}
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-12 col-md-2 mb-3 text-start">
                        <label className="form-label">Branch</label>

                        <Select
                          value={branch}
                          options={branchOptions}
                          className="select"
                          placeholder="Select Branch"
                          onChange={setBranch}
                          allowClear
                          style={{ width: "100%", height: "38px" }}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-3 text-start">
                        <label className="form-label">Date</label>
                        <Space direction="vertical" size={12}>
                          <RangePicker
                            format="YYYY-MM-DD"
                            value={dateRange}
                            onChange={onChange}
                            style={{ width: "100%" }}
                          />
                        </Space>
                      </div>
                    </div>
                  </div>

                  <div
                    className="container mt-0"
                    style={{
                      maxWidth: "100%",
                      marginLeft: "20px",
                      marginRight: "40px",
                    }}
                  >
                    <div className="row d-flex align-items-center justify-content-start">
                      <div className="col-12 col-md-2 mb-3 text-start">
                        <button
                          className="btn btn-submit"
                          onClick={getSeachData}
                          style={{ height: "38px", width: "55%" }}
                        >
                          {loading ||
                          loading1 ||
                          loading2 ||
                          loading3 ||
                          loading4
                            ? "Search "
                            : "Search"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card table-list-card-grid">
                <div className="card-body-grid">
                  <Tabs
                    defaultActiveKey="1"
                    onChange={(key) => setCurrentTab(key)}
                    rowClassName={() => "custom-row"}
                  >
                    <TabPane
                      tab={
                        <span style={{ fontWeight: "bold", marginLeft: 10 }}>
                          Leaves
                        </span>
                      }
                      key="1"
                      rowClassName={() => "custom-row"}
                    >
                      <div className="table-responsive">
                        <Table
                          loading={loading}
                          columns={columns}
                          dataSource={dataSource}
                          rowKey={(record) => record.id}
                          rowClassName={() => "custom-row"}
                          className="custom-ant-table"
                          pagination={{
                            current: pagination.current,
                            total: dataSource.length,
                            pageSizeOptions: ["5", "10", "20", "50"],
                            showSizeChanger: true,
                            showQuickJumper: true,
                            showTotal: (total) => `Total ${total} items`,
                          }}
                          onChange={handleTableChange}
                        />
                      </div>
                    </TabPane>
                    <TabPane
                      rowClassName={() => "custom-row"}
                      tab={
                        <span style={{ fontWeight: "bold", marginLeft: 10 }}>
                          Short Leaves
                        </span>
                      }
                      key="2"
                    >
                      <div className="table-responsive">
                        <Table
                          rowClassName={() => "custom-row"}
                          loading={loading1}
                          columns={columns1}
                          dataSource={shortLeaves}
                          rowKey={(record) => record.id}
                          className="custom-ant-table"
                          pagination={{
                            current: pagination.current,
                            total: shortLeaves.length,
                            pageSizeOptions: ["5", "10", "20", "50"],
                            showSizeChanger: true,
                            showQuickJumper: true,
                            showTotal: (total) => `Total ${total} items`,
                          }}
                          onChange={handleTableChange}
                        />
                      </div>
                    </TabPane>
                    <TabPane
                      rowClassName={() => "custom-row"}
                      tab={
                        <span style={{ fontWeight: "bold", marginLeft: 10 }}>
                          Duty Leaves
                        </span>
                      }
                      key="3"
                    >
                      <div className="table-responsive">
                        <Table
                          rowClassName={() => "custom-row"}
                          loading={loading2}
                          columns={columns2}
                          dataSource={dutyLeaves}
                          rowKey={(record) => record.id}
                          className="custom-ant-table"
                          pagination={{
                            current: pagination.current,
                            total: dutyLeaves.length,
                            pageSizeOptions: ["5", "10", "20", "50"],
                            showSizeChanger: true,
                            showQuickJumper: true,
                            showTotal: (total) => `Total ${total} items`,
                          }}
                          onChange={handleTableChange}
                        />
                      </div>
                    </TabPane>
                    <TabPane
                      rowClassName={() => "custom-row"}
                      tab={
                        <span style={{ fontWeight: "bold", marginLeft: 10 }}>
                          Special Leaves
                        </span>
                      }
                      key="4"
                    >
                      <div className="table-responsive">
                        <Table
                          rowClassName={() => "custom-row"}
                          loading={loading3}
                          columns={columns3}
                          dataSource={specialLeaves}
                          rowKey={(record) => record.id}
                          className="custom-ant-table"
                          pagination={{
                            current: pagination.current,
                            total: specialLeaves.length,
                            pageSizeOptions: ["5", "10", "20", "50"],
                            showSizeChanger: true,
                            showQuickJumper: true,
                            showTotal: (total) => `Total ${total} items`,
                          }}
                          onChange={handleTableChange}
                        />
                      </div>
                    </TabPane>
                    <TabPane
                      rowClassName={() => "custom-row"}
                      tab={
                        <span style={{ fontWeight: "bold", marginLeft: 10 }}>
                          Maternity Leaves
                        </span>
                      }
                      key="5"
                    >
                      <div className="table-responsive">
                        <Table
                          rowClassName={() => "custom-row"}
                          loading={loading4}
                          columns={columns4}
                          dataSource={maternityLeaves}
                          rowKey={(record) => record._id}
                          className="custom-ant-table"
                          pagination={{
                            current: pagination.current,
                            total: maternityLeaves.length,
                            pageSizeOptions: ["5", "10", "20", "50"],
                            showSizeChanger: true,
                            showQuickJumper: true,
                            showTotal: (total) => `Total ${total} items`,
                          }}
                          onChange={handleTableChange}
                        />
                      </div>
                    </TabPane>
                    <TabPane
    rowClassName={() => "custom-row"}
    tab={<span style={{ fontWeight: "bold", marginLeft: 10 }}>Authorized No Pay Leaves</span>}
    key="6"
  >
    <div className="table-responsive">
      <Table
        rowClassName={() => "custom-row"}
        loading={loading5}
        columns={columns5}
        dataSource={authorizedNoPayLeaves}
        rowKey={(record) => record.id}
        className="custom-ant-table"
        pagination={{
          current: pagination.current,
          total: authorizedNoPayLeaves.length,
          pageSizeOptions: ["5", "10", "20", "50"],
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total) => `Total ${total} items`,
        }}
        onChange={handleTableChange}
      />
    </div>
  </TabPane>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BulkUploadModal
        handleCancel={() => setIsBulkUploadOpen(false)}
        isVisible={isBulkUploadOpen}
        onUploadData={getSeachData}
      />
      <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <button
            key="cancel"
            className="btn btn-cancel"
            onClick={() => setPageSizeModalVisible(false)}
          >
            Cancel
          </button>,
          <button
            key="submit"
            className="btn btn-submit"
            onClick={handlePageSizeChange}
          >
            Apply
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select
            style={{ width: "100%" }}
            value={tempPageSize}
            onChange={(value) => setTempPageSize(value)}
          >
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
     <Modal
        title="Adjust Maternity Leave Dates"
        visible={isAdjustDateModalVisible}
        onOk={handleAdjustDateSubmit}
    onCancel={handleCancelModal}
        okText="Save"
        cancelText="Cancel"
        width={600}
        bodyStyle={{ padding: "24px" }}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="startDate"
            label="Start Date"
            rules={[{ required: true, message: "Please select the start date" }]}
          >
            <input
              className="ant-input"
              ref={(node) => {
                if (node) {
                  Flatpickr(node, {
                    dateFormat: "Y-m-d",
                    minDate: "today",
                    maxDate: "2030-12-31",
                    defaultDate: form.getFieldValue("startDate") || null,
                    onChange: ([date]) => {
                      form.setFieldsValue({
                        startDate: date ? moment(date).format("YYYY-MM-DD") : null,
                      });
                      const endDate = form.getFieldValue("endDate");
                      if (endDate && date) {
                        setLeaveDays(
                          getDateRangeArray(new Date(date), new Date(endDate))
                            .map(d => moment(d).format("YYYY-MM-DD"))
                        );
                      }
                    },
                  });
                }
              }}
              placeholder="Select start date"
            />
          </Form.Item>
          <Form.Item
            name="endDate"
            label="End Date"
            rules={[{ required: true, message: "Please select the end date" }]}
            dependencies={["startDate"]}
          >
            <input
              className="ant-input"
              ref={(node) => {
                if (node) {
                  Flatpickr(node, {
                    dateFormat: "Y-m-d",
                    minDate: form.getFieldValue("startDate") || "today",
                    maxDate: "2030-12-31",
                    defaultDate: form.getFieldValue("endDate") || null,
                    onChange: ([date]) => {
                      form.setFieldsValue({
                        endDate: date ? moment(date).format("YYYY-MM-DD") : null,
                      });
                      const startDate = form.getFieldValue("startDate");
                      if (startDate && date) {
                        setLeaveDays(
                          getDateRangeArray(new Date(startDate), new Date(date))
                            .map(d => moment(d).format("YYYY-MM-DD"))
                        );
                      }
                    },
                  });
                }
              }}
              placeholder="Select end date"
            />
          </Form.Item>
          <Form.Item
            name="expectedDeliveryDate"
            label="Expected Delivery Date"
            rules={[{ required: true, message: "Please select the expected delivery date" }]}
            dependencies={["startDate", "endDate"]}
          >
            <input
              className="ant-input"
              ref={(node) => {
                if (node) {
                  Flatpickr(node, {
                    dateFormat: "Y-m-d",
                    minDate: form.getFieldValue("startDate") || "today",
                    maxDate: form.getFieldValue("endDate") || "2030-12-31",
                    defaultDate: form.getFieldValue("expectedDeliveryDate") || null,
                    onChange: ([date]) => {
                      form.setFieldsValue({
                        expectedDeliveryDate: date ? moment(date).format("YYYY-MM-DD") : null,
                      });
                    },
                  });
                }
              }}
              placeholder="Select expected delivery date"
            />
          </Form.Item>
     <Form.Item label="Leave Days">
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
    {leaveDays.length > 0 ? (
      leaveDays.map((date) => (
        <div
          key={date}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '8px 12px',
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            backgroundColor: '#fff',
            width: 'calc(25% - 12px)', 
            boxSizing: 'border-box',
            justifyContent: 'space-between',
            marginBottom: '8px',
          }}
        >
          <span>{date}</span>
          <Button
            type="link"
            danger
            onClick={() => handleRemoveDate(date)}
            style={{ padding: 0 }}
          >
                          <i data-feather="trash-2" className="feather-trash-2"></i>

          </Button>
        </div>
      ))
    ) : (
      <div>No leave days selected</div>
    )}
  </div>
</Form.Item>
        </Form>
      </Modal>
      <Modal
        // title="Apply Maternity Leave"
        open={isAddMaternityModalOpen}
        onCancel={() => setIsAddMaternityModalOpen(false)}
        footer={null}
        width={800}
      >
        <AddMaternityLeave
          handleCancel={() => setIsAddMaternityModalOpen(false)}
          onSuccess={() => {
            setIsAddMaternityModalOpen(false);
            getSeachData(); // Refresh maternity leaves table
          }}
        />
      </Modal>
       <Modal
              open={addModalVisible}
              onCancel={() => setAddModalVisible(false)}
              footer={null}
            >
              <AddAuthorizedNoPayLeave
                handleCancel={() => setAddModalVisible(false)}
                          onSuccess={handleAddModalSuccess}

              />
            </Modal>
    </div>
  );
};

export default LeavesAdmin;
